import { Button, Input, Space } from "antd"
const StarRating = ({ rating }) => {
    const stars = [];
    for (let i = 1; i <= 5; i++) {
        if (i <= rating) {
            stars.push(<li><a ><i className="fas fa-star" /></a></li>);
        } else if (i - rating < 1) {
            stars.push(<li><a ><i className="fas fa-star-half-alt" /></a></li>);
        } else {
            stars.push(<li><a ><i className="far fa-star" /></a></li>);
        }
    }
    return stars;
};
function ReviewRating({ detailProperti, allowReview, handleSubmitReply, handleReplyReview, replyingTo, replyText, setReplyText }) {
    return (
        <div className="ltn__shop-details-tab-content-inner--- ltn__shop-details-tab-inner-2 ltn__product-details-review-inner mb-60">
            <h4 className="title-2">Ulasan Pelanggan</h4>
            {/* Daftar semua review */}
            <div className="product-all-review mt-20">
                {detailProperti?.reviews.allReview.map((review) => (
                    <div key={review.id} className="single-review">

                        {/* comment-area */}
                        <div className="ltn__comment-area mb-30">
                            <div className="ltn__comment-inner">
                                <ul>
                                    <li>
                                        <div className="ltn__comment-item clearfix">
                                            <div className="ltn__commenter-comment">
                                                <h6><span style={{ cursor: 'default' }}>{review.created_by}</span></h6>
                                                <div className="product-ratting">
                                                    <ul>
                                                        <StarRating rating={review.rating} />

                                                    </ul>
                                                </div>
                                                <p>{review.comment}</p>
                                                <span className="ltn__comment-reply-btn">{new Date(review.created_at).toLocaleDateString(
                                                    "id-ID",
                                                    {
                                                        day: "numeric",
                                                        month: "long",
                                                        year: "numeric",
                                                    }
                                                )}</span>
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        {review?.reply_comment ?
                            <div className="reviewer-info">
                                <strong>Balasan pemilik untuk {review.created_by}</strong>
                                <p>{review.reply_comment}</p>

                            </div>
                            :
                            <>
                                {allowReview &&

                                    <div style={{ marginTop: '10px' }}>
                                        <Space direction="vertical" style={{ width: '100%' }}>
                                            <Button
                                                type="link"
                                                size="small"
                                                onClick={() => handleReplyReview(review)}
                                            >
                                                {replyingTo === review.id ? 'Batal Balas' : 'Balas Review'}
                                            </Button>


                                            {replyingTo === review.id && (
                                                <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                                                    <Input
                                                        placeholder="Tulis balasan Anda..."
                                                        value={replyText}
                                                        onChange={(e) => setReplyText(e.target.value)}
                                                        onPressEnter={() => handleSubmitReply(review.id)}
                                                        style={{ flex: 1 }}
                                                    />
                                                    <Button
                                                        type="primary"
                                                        size="small"
                                                        onClick={() => handleSubmitReply(review.id)}
                                                    >
                                                        Kirim
                                                    </Button>
                                                </div>
                                            )}
                                        </Space>
                                    </div>}

                            </>

                        }

                        {/* Display replies if any */}
                        {review.replies && review.replies.length > 0 && (
                            <div className="review-replies" style={{ marginTop: '15px', marginLeft: '20px' }}>
                                {review.replies.map((reply, index) => (
                                    <div key={index} className="single-reply" style={{ backgroundColor: '#f5f5f5', padding: '10px', borderRadius: '5px', marginBottom: '10px' }}>
                                        <div className="reply-info">
                                            <strong>Pemilik Property</strong>
                                        </div>
                                        <p>{reply.comment || reply.reply}</p>
                                        <small>
                                            {new Date(reply.created_at).toLocaleDateString(
                                                "id-ID",
                                                {
                                                    day: "numeric",
                                                    month: "long",
                                                    year: "numeric",
                                                }
                                            )}
                                        </small>
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                ))}
            </div>
        </div>)
}

export default ReviewRating